import permissions from '../permission-list'

export default [
  {
    path: '/v2/transactions',
    name: 'transactions-v2',
    component: () => import('@/views/v2/Transactions.vue'),
    meta: {
      pageTitle: 'Daftar Transaksi',
      resource: permissions.transactionV2,
      action: 'read',
      navActiveLink: 'transactions-v2',
      localstorage: {
        query: 'transactions-v2-query',
      },
      breadcrumb: [
        {
          text: 'Transaksi',
          active: true,
        },
      ],
    },
  },
]
